// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3_Sfd","title":"Images45_title__2M-ar","images":"Images45_images__2B92m"};